module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "goods-list-page"
    }
  }, [_c('div', {
    staticClass: "breadcrumb wrapper",
    staticStyle: {
      "line-height": "30px"
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', [_vm._v("推荐商品")])]), _vm._v(" "), _c('div', {
    staticClass: "container wrapper clearfix"
  }, [(_vm.$route.query.type == 4) ? _c('div', {
    staticStyle: {
      "float": "left",
      "height": "100%",
      "width": "200px",
      "background-color": "#fff",
      "padding": "8px",
      "box-sizing": "border-box"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "center",
      "background-color": "rgb(236, 103, 26)",
      "color": "#fff",
      "line-height": "30px",
      "border-radius": "8px"
    }
  }, [_vm._v("商品类型选择")]), _vm._v(" "), _c('el-scrollbar', {
    staticStyle: {
      "height": "600px"
    }
  }, _vm._l((_vm.couponTypeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-type-box",
      class: _vm.couponActiveIndex == index ? 'coupon-active' : '',
      on: {
        "click": function($event) {
          return _vm.selectType(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right",
    attrs: {
      "id": "result"
    }
  }, [_c('div', {
    staticClass: "shop_con_list",
    attrs: {
      "id": "main-nav-holder"
    }
  }, [(this.list.length == 0 && !this.loading) ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_vm._v("\n          抱歉,暂无推荐商品!\n        ")]) : _vm._e(), _vm._v(" "), (_vm.type != 10) ? _c('right-goods', {
    attrs: {
      "data": _vm.list
    }
  }) : _c('exchange-goods', {
    attrs: {
      "data": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0 && _vm.couponActiveIndex !== 0),
      expression: "total > 0 && couponActiveIndex !== 0"
    }],
    staticClass: "page-wrapper"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.page,
      "page-size": _vm.pageSize,
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261e6c4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/recommend-goods.vue
// module id = 1554
// module chunks = 1